export default function PHP_ftp_rename() {
  return (
    <div>
      <h1>PHP_ftp_rename</h1>
    </div>
  );
}
